import React, { useEffect, useRef } from "react";

const TermsandConditions = () => {
  const pageRef = useRef(null);

  useEffect(() => {
    const sections = pageRef.current.querySelectorAll(".fade-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <div className="bg-[#F7FAF9] min-h-screen pt-10 pb-20" ref={pageRef}>
      <div className="max-w-5xl mx-auto px-4">

        {/* Head */}
        <div className="bg-white border border-gray-200 rounded-3xl shadow-lg p-6 fade-section">
          <h1 className="text-3xl font-extrabold text-teal-700 text-center mb-2">
            Terms & Conditions
          </h1>
          <p className="text-center text-gray-600 text-sm mb-6">
            Last Updated: January 2025
          </p>

          <p className="font-semibold text-lg text-gray-900 mb-3">
            BookTrip4Me – Travel Booking Services
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            Welcome to BookTrip4Me. By using our website or booking travel
            services, you agree to these Terms and Conditions. Please read them
            carefully before proceeding.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-8 mt-8">

          {/* SECTION */}
          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              1. General Overview
            </h2>
            <p className="text-gray-700 leading-relaxed">
              BookTrip4Me operates as an independent travel agency facilitating
              bookings with airlines, hotels, car rental companies, and cruise
              lines. We do not operate the services booked through our platform.
              Users must be 18+ to use our service.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              2. Booking and Confirmation
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>All bookings depend on provider availability.</li>
              <li>Confirmation will be emailed after payment.</li>
              <li>Users must verify booking details for accuracy.</li>
              <li>Booking for others requires consent.</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              3. Payments and Pricing
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Prices may change until payment is completed.</li>
              <li>Full payment is required at booking unless stated otherwise.</li>
              <li>Prices may include fees, taxes, and surcharges.</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              4. Changes, Cancellations & Refunds
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Each service provider has its own rules.</li>
              <li>Modifications may require fees.</li>
              <li>Refunds follow provider policies (7–30 days).</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              5. Travel Documents & Identification
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Users are responsible for valid passports, visas, IDs.</li>
              <li>BookTrip4Me is not liable for denied boarding.</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              6. User Responsibility
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Provide accurate personal info.</li>
              <li>No fraudulent or unlawful use.</li>
              <li>Misuse may lead to service denial.</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              7. Liability Disclaimer
            </h2>
            <p className="text-gray-700 leading-relaxed">
              BookTrip4Me is not responsible for delays, cancellations, lost
              luggage, service quality, or actions of third-party providers.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              8. Intellectual Property
            </h2>
            <p className="text-gray-700 leading-relaxed">
              All content including logos, icons, and text belongs to
              BookTrip4Me and cannot be reproduced without permission.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              9. Privacy Policy
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Using our services means you agree to our data collection and
              usage practices as described in our Privacy Policy.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 fade-section">
            <h2 className="text-xl font-bold text-teal-700 mb-2">
              10. Governing Law
            </h2>
            <p className="text-gray-700 leading-relaxed">
              All disputes will be governed under the jurisdiction where
              BookTrip4Me is registered.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-3xl shadow p-6 text-center fade-section">
            <p className="font-semibold text-gray-900">
              By using BookTrip4Me, you agree to these Terms and Conditions.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TermsandConditions;
